'use client';
import { Box, Container, Flex, Heading } from '@chakra-ui/react';
import { getImageProps } from 'next/image';
import { Autoplay, EffectFade, Navigation } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/effect-fade';

import LinkCustom from '@/app/_components/link/LinkCustom';
import { assetsUri } from '@/services/api.service';
import { getDownloadLink } from '@/services/link.service';
import { ImageTransformationKeys } from '@/types/files/files.types';
import { directusImageLoader } from '@/utils/loaders';

import styles from './HeroBanner.module.scss';

type FleetBanner = {
  call_to_action_text_2: string;
  call_to_action_text: string;
  call_to_action_url_2: string;
  call_to_action_url: string;
  desktop_image: string;
  heading: string;
  mobile_image: string;
};
const HeroBanner = ({
  bannerSlider = [],
  imageKeys,
}: {
  bannerSlider: FleetBanner[];
  imageKeys: ImageTransformationKeys;
}) => {
  return (
    <>
      <Swiper
        effect={'fade'}
        autoplay={{
          delay: 4500,
        }}
        loop={false}
        navigation={false}
        modules={[EffectFade, Navigation, Autoplay]}
        breakpoints={{
          0: {
            slidesPerView: 1,
            spaceBetween: 0,
          },
          768: {
            slidesPerView: 1,
            spaceBetween: 0,
          },
          1024: {
            slidesPerView: 1,
            spaceBetween: 0,
          },
        }}
        className={styles.heroSwiper}
      >
        {bannerSlider?.map((fleetBanner: FleetBanner, index: number) => {
          const common = {
            alt: 'Hero',
            width: 1280,
            height: 681,
            loader: directusImageLoader,
          };
          const {
            props: { srcSet: mobile },
          } = getImageProps({
            ...common,
            src: `${assetsUri}/${fleetBanner.mobile_image}?key=${imageKeys.mobileKey}`,
            priority: index === 0,
          });
          const {
            props: { srcSet: desktop, ...rest },
          } = getImageProps({
            ...common,
            src: `${assetsUri}/${fleetBanner.desktop_image}?key=${imageKeys.desktopKey}`,
            priority: index === 0,
          });

          return (
            <SwiperSlide key={index}>
              <Box
                className={styles.heroSwiperWrap}
                display={'flex'}
                alignItems={'flex-end'}
                justifyContent={'center'}
                flexDirection={{ base: 'column', lg: 'row' }}
                height={{ base: 'auto', lg: '810px' }}
              >
                <picture className={styles.heroImage}>
                  <source media="(max-width: 575px)" srcSet={mobile} />
                  <source media="(min-width: 576px)" srcSet={desktop} />
                  <img {...rest} alt="hero-banner-image" />
                </picture>
                <Container
                  className={styles.heroBannerContentWrapper}
                  maxW={'1280'}
                  width={'100%'}
                  alignContent={'center'}
                  zIndex={1}
                  paddingX={{ base: 6 }}
                  paddingY={'56px'}
                  marginTop={'auto'}
                >
                  <div className={styles.heroBannerContent}>
                    <div className={styles.headingElement}>
                      <Heading
                        as="h1"
                        className={styles.titleLg}
                        color={'white'}
                        textAlign={'center'}
                        marginBottom={8}
                      >
                        {fleetBanner?.heading}
                      </Heading>
                      <Flex
                        direction={{ base: 'column', sm: 'row' }}
                        justifyContent={'center'}
                        gap="4"
                        paddingBottom={{ sm: '80px' }}
                      >
                        <LinkCustom
                          linkText={fleetBanner?.call_to_action_text}
                          className="btnWhite"
                          moduleClass={styles.bannerCta}
                          href={getDownloadLink(
                            fleetBanner?.call_to_action_url,
                          )}
                          download
                        />
                        <LinkCustom
                          linkText={fleetBanner?.call_to_action_text_2}
                          className="btnOutlineWhite"
                          moduleClass={styles.bannerCta}
                          href={fleetBanner?.call_to_action_url_2}
                        />
                      </Flex>
                    </div>
                  </div>
                </Container>
              </Box>
            </SwiperSlide>
          );
        })}
      </Swiper>
    </>
  );
};

export default HeroBanner;
